<template>
  <div class="md-layout">
    <div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-large-size-80 md-xlarge-size-70 page-container">
      <div class="md-layout">
        <div class="md-layout-item md-size-20 page-container-side text-right">
          <div><h2>{{$t('address')}}</h2></div>
        </div>
        <div class="md-layout-item md-size-80">
          <div class="page-container-section">
            <div class="md-layout">
              <div class="md-layout-item">       
                <div><h3 class="page-sub-title">{{$t('shipping-information')}}</h3></div>
                <p>{{$t('replace-sent-address')}}</p>
              </div>
            </div>
            
            <div class="md-layout md-gutter" v-if="type=='card'">
              <div class="md-layout-item md-size-50 md-small-size-100 card-col" v-for="item in addressList" v-bind:key="item.id">
                <address-card :address="item" :selected="selected" v-on:select="select" v-on:update="update" />
              </div>
            </div>
            <div class="md-layout" v-if="type=='form'">
              <div class="md-layout-item">
                <address-form v-on:cancel="cancelForm" v-on:submit="submitForm" v-on:back="back" :addressData="addressUpdate" :addressList="addressList" />
              </div>
            </div>
            <div class="md-layout" v-if="showAddressError">
              <div class="md-layout-item md-error text-right">
               {{$t('select-shipping-address')}} 
              </div>
            </div>
            <div class="md-layout" v-if="type=='card'">
              <div class="md-layout-item md-size-50">
                <md-button type="button" class="md-raised md-accent" v-on:click="newAddress()" :disabled="loading">{{$t('new-address')}} </md-button>
              </div>
              <div class="md-layout-item md-size-50 text-right">
                <md-button type="button" class="md-accent" v-on:click="back()" :disabled="loading">{{$t('back')}}</md-button>
                <md-button type="submit" class="md-raised md-primary" :disabled="loading" v-on:click="submit">
                  {{$t('submit')}} <md-progress-spinner class="md-primary" md-mode="indeterminate" :md-value="80" :md-diameter="14" :md-stroke="2" v-if="loading"></md-progress-spinner>
                </md-button>
              </div>
            </div>
            <div class="md-layout">
              <p style="color:#2196f3" v-html="$t('deliver-unable-info')"></p>
            </div>
          </div>
        </div>
      </div>
      <div class="md-layout">
        <div class="md-layout-item">
          <md-snackbar :md-active.sync="showErrorMsg" :md-duration="8000">{{$t('encountered-error')}}</md-snackbar>
        </div>
      </div>
      <full-page-loading :show="fullPageLoading" :error="showErrorMsg" />
    </div>
  </div>
</template>

<script>
  import AddressCard from '../components/AddressCard'
  import AddressForm from '../components/AddressForm'
  import FullPageLoading from '../components/FullPageLoading'

  import { mapState, mapMutations,mapActions } from 'vuex'
  import * as types from '../store/mutation-types'
  import Auth from '../mixins/auth'
  import { storeList, getStoreCodeByUrl, languageCode } from '../mixins/store'
  import { apiServer, publicPath, router, i18n } from '../config'

  export default {
    name: 'YourAddress',
    components: {
      AddressCard,
      AddressForm,
      FullPageLoading
    },
    computed: {
      ...mapState({
        store: 'store',
        step: 'step'
      })
    },
    data: () => ({
      sending: false,
      loading: false,
      fullPageLoading: true,
      type: 'card',
      addressList: [],
      selected: null,
      addressUpdate: null,
      countryId: null,
      countryCode: '',
      countryName: '',
      countryList: [],
      address: {},
      showAddressError: false,
      showErrorMsg: false
    }),
    created() {
      this.loading = true
      this.showPageLoading()
      let code = getStoreCodeByUrl(location.href)
      if (!code || code.length == 0) code = localStorage.rma_store
      if (code && storeList.indexOf(code) >= 0) this.changeStore(code)
      i18n.locale = languageCode[this.store] ? languageCode[this.store] : 'en'
      this.updatePageTitle(this.$t('page-title'))

      this.$http.request({ url: `${apiServer}/api/your-address?store=${this.store}`, method: 'get', headers: { Authorization: `Bearer ${Auth.getToken()}`, Member: Auth.getMemberToken() } }).then(({ data }) => {
        if (data && data.status == 'fail') {
          this.$router.push(`${publicPath}`)
        }
        else {
          this.fullPageLoading = false
          window.console.log(data.items)
          if (data && data.items) this.addressList = data.items
          if (data && data.address) {
            this.address = data.address
          }
          if (data) {
            this.countryCode = data.countryCode
            this.countryId = data.countryId
            this.countryName = data.countryName
            
          }
          if (!this.addressList || this.addressList.length == 0) {
            this.addressUpdate = {
              ...this.address,
              countryId: this.countryId,
              countryName: this.countryName,
              countryCode: this.countryCode
            }
            this.type = 'form'
          }
        }
        this.loading = false
        this.hidePageLoading()
      }).catch(() => {
        this.loading = false
        this.hidePageLoading()
      })
      this.$scrollTo('#app')
    },
    methods: {
      ...mapMutations({
        changeStore: types.CHANGE_STORE,
        changeStep: types.CHANGE_STEP,
        showPageLoading: types.SHOW_LOADING,
        hidePageLoading: types.HIDE_LOADING,
        showLogin: types.SHOW_DROP_MENU,
        setupLoginForm: types.CHANGE_DROP_MENU
      }),          
      ...mapActions({
        updatePageTitle: types.SET_PAGE_TITLE
      }),
      newAddress() {
        this.addressUpdate = { countryId: this.countryId, countryName: this.countryName, countryCode: this.countryCode }
        this.type = 'form'
        this.$scrollTo('#app')
      },
      cancelForm() {
        this.type = 'card'
        this.$scrollTo('#app')
      },
      submitForm(item) {
        //window.console.log(item)
        this.showPageLoading()
        if (this.addressList == null || this.addressList.length == 0) {
          this.address = { ...item }
          this.submit()
        }
        else {
          this.$http.post(`${apiServer}/api/your-address/update`, { ...item }, { headers: { Authorization: `Bearer ${Auth.getToken()}`, Member: Auth.getMemberToken() } }).then(({ data }) => {
            if (data && data.items) this.addressList = data.items
            this.type = 'card'
            this.hidePageLoading()
            this.$scrollTo('#app')
          }).catch(() => {
            this.showErrorMsg = true
            this.hidePageLoading()
          })
        }
      },
      select(item) {
        //window.console.log(item)
        this.selected = item
        this.address = { ...item }
        this.showAddressError = false
      },
      update(item) {
        //window.console.log(item)
        this.addressUpdate = item
        this.type = 'form'
        this.$scrollTo('#app')
      },
      back() {        
        router.push(`${publicPath}`)
      },
      submit() {
        if (
          this.address == null || !this.address.countryId || this.address.countryId <= 0
        ) {
          this.showAddressError = true
          return
        }

        // Clean up phone number format
        if (this.address.mobile1) this.address.mobile1 = this.address.mobile1.replace(/\//gi, "-"); 
        if (this.address.mobile2) this.address.mobile2 = this.address.mobile2.replace(/\//gi, "-"); 

        this.showPageLoading()
        this.loading = true
        this.$http.post(`${apiServer}/api/your-address/submit`, {
          store: this.store,
          address: { ...this.address }
        }, { headers: { Authorization: `Bearer ${Auth.getToken()}`, Member: Auth.getMemberToken() } }).then(({ data }) => {
          if (data && data.status == 'success' && data.rmaNo && data.rmaId) {
            localStorage.rma_rmaNo = data.rmaNo
            localStorage.rma_rmaId = data.rmaId
            this.$router.push(`${publicPath}/confirmation`)
          }
          else {
            this.showErrorMsg = true
            alert(JSON.stringify(data))
          }
          this.hidePageLoading()
          this.loading = false
        }).catch(() => {
          this.hidePageLoading()
          this.loading = false
          this.showErrorMsg = true
        })
      },
      refresh() {
        location.reload()
        return
      }
    }
  }
</script>


<style lang="scss" scoped>

  @import "~vue-material/dist/theme/engine";

  .card-col {
    padding-bottom: 20px;
  }

</style>